export const tailwindConfig = {
  fontFamily: {
    sans: ['Rubik'],
  },
  extend: {
    colors: {
      navyPrime: '#002953',
      primeval: {
    50: '#fff1f0',
    100: '#ffe0dd',
    200: '#ffc5c0',
    300: '#ff9d94',
    400: '#ff6557',
    500: '#ff3623',
    600: '#f91500',
    700: '#d71200',
    800: '#b11203',
    900: '#92150a',
    950: '#500700'
      },
      secondary: {
    50: '#ecf9ff',
    100: '#d5efff',
    200: '#b4e5ff',
    300: '#81d7ff',
    400: '#46bdff',
    500: '#1b9cff',
    600: '#047bff',
    700: '#0064f8',
    800: '#0550c8',
    900: '#0a3c85',
    950: '#0d2b5e',
      },
      shade: {
        50: '#fffbec',
        100: '#fff6d3',
        200: '#ffe9a5',
        300: '#ffd66d',
        400: '#ffb932',
        500: '#ffa10a',
        600: '#ff8900',
        700: '#cc6402',
        800: '#a14d0b',
        900: '#82410c',
        950: '#461f04'
      },
      success: {
        50: '#f0fdf4',
        100: '#dcfce6',
        200: '#bbf7cf',
        300: '#85f0aa',
        400: '#49df7d',
        500: '#23d160',
        600: '#15a447',
        700: '#14813b',
        800: '#166533',
        900: '#14532c',
        950: '#052e15',
      },
      info: {
        50: '#f0f8ff',
        100: '#e0effe',
        200: '#bbe0fc',
        300: '#7fc7fa',
        400: '#3bacf5',
        500: '#209cee',
        600: '#0572c4',
        700: '#065b9e',
        800: '#094d83',
        900: '#0e426c',
        950: '#092948',
      },
      warning: {
        50: '#fefbe8',
        100: '#fff7c2',
        200: '#ffec89',
        300: '#ffdd57',
        400: '#fdc412',
        500: '#ecaa06',
        600: '#cc8202',
        700: '#a35b05',
        800: '#86480d',
        900: '#723b11',
        950: '#431d05',
      },
      danger: {
        50: '#ffefef',
        100: '#ffdcdc',
        200: '#ffbfbf',
        300: '#ff9292',
        400: '#ff5454',
        500: '#ff1f1f',
        600: '#ff0000',
        700: '#db0000',
        800: '#b40000',
        900: '#940808',
        950: '#520000',
      },
      leftArrow: '#111111',
    }, 
    height: {
      '30': '120px'
    } 
  }
};